<div class="publisher-header">
  <h3>{{ 'agent:panel.visio.me' | translate }}</h3>
</div>
<div #screenSharingPublisherContainer class="screen-content"></div>
<div #visioPublisherContainer class="publisher-content">
  <div class="actions-container">
    <button
      (click)="toggleLocalAudio()"
      [attr.aria-pressed]="localAudioEnabled"
      [disabled]="!(hasPermission$('CSR_VISIO_OUTGOING::microphone_sound:disable') | async)"
      [ngClass]="{ enabled: localAudioEnabled }"
      class="cng-ico_media_micro"
      title="{{ 'agent:panel.visio.microphone' | translate }} {{ 'commons:basic.channels.' + getState(localAudioEnabled) | translate }}"
      type="button"
    ></button>
    <button
      (click)="toggleLocalVideo()"
      [attr.aria-pressed]="localVideoEnabled"
      [disabled]="!(hasPermission$('CSR_VISIO_OUTGOING::video_stream:disable') | async)"
      [ngClass]="{ enabled: localVideoEnabled }"
      class="cng-ico_visio"
      title="{{ 'agent:panel.visio.camera' | translate }} {{ 'commons:basic.channels.' + getState(localVideoEnabled) | translate }}"
      type="button"
    ></button>
    <button
      (click)="startScreenSharing()"
      [attr.aria-pressed]="hasScreenSharing$ | async"
      [ngClass]="{ enabled: (hasScreenSharing$ | async) }"
      class="cng-ico_cobrowsing"
      title="{{ 'agent:panel.visio.screenSharing' | translate }} {{
        'commons:basic.channels.' + getState(hasScreenSharing$ | async) | translate
      }}"
      type="button"
    ></button>
  </div>
</div>
